/* eslint-disable func-names */

/**
 * @fileOverview Emulate a youtube video player and load the true video when the
 *     container is clicked.
 * @author Selectra Front End Team
 * @version 1.1.0
 */


/**
 * @function youtubeEmbed
 * @description Checks if there is youtube-embed classes on the page, then for
 *     each video creates a fake player with the thumb of the Youtube video
 *     which on click will be replaced by the true Youtube player iframe.
 */
export default function youtubeEmbed() {

  Array.from( document.getElementsByClassName( 'youtube-embed' ))
    .forEach( player => {
      if ( !player.dataset.wasProcessed ) {

        const

          // Create placeholder elements.
          placeholder = document.createElement( 'div' ),
          play = document.createElement( 'div' ),
          videoId = player.dataset.id,
          thumbnail = ( function() {
            const thumb = document.createElement( 'img' );
            thumb.src = `https://i.ytimg.com/vi/${ videoId }/hqdefault.jpg`;
            thumb.classList.add( 'youtube-embed__img' );
            thumb.alt = player.dataset.alt || 'Video preview';
            return thumb;
          }());

        console.log( `youtube-embed: ${ videoId }` );

        play.classList.add( 'youtube-embed__play' );

        placeholder.setAttribute( 'data-id', videoId );
        placeholder.appendChild( thumbnail );
        placeholder.appendChild( play );

        // Click callback: Replace the placeholder with the video iframe.
        placeholder.onclick = function() {
          const iframe = document.createElement( 'iframe' );
          iframe.classList.add( 'youtube-embed__iframe' );
          iframe.setAttribute( 'src',
            `https://www.youtube.com/embed/${ videoId }?autoplay=1` );
          iframe.setAttribute( 'frameborder', '0' );
          iframe.setAttribute( 'allowfullscreen', '1' );
          this.parentNode.replaceChild( iframe, this );
        };

        // Append placeholder to DOM, set processed.
        player.appendChild( placeholder );
        player.dataset.wasProcessed = true;
      }
    });

}
